import { render } from "./DeleteGlobalProfileOverlay.vue?vue&type=template&id=79948b9b"
import script from "./DeleteGlobalProfileOverlay.vue?vue&type=script&lang=js"
export * from "./DeleteGlobalProfileOverlay.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__